export default {
  screens: [
    {
      type: 'intro',
      title: '변형 가능한 주얼리 예술',
      content:
        '프롬나드 임페리얼(Promenades Impériales) 컬렉션은 러시아와 시베리아 겨울의 아름다움에 경의를 표합니다. 이 컬렉션을 통해 변형 가능한 주얼리를 제작하는 쇼메의 탁월한 주얼리 메이킹 기법을 엿볼 수 있습니다. 파파라차 사파이어가 세팅된 네크리스는 브로치 등 다양한 스타일로 연출이 가능합니다.',
      idYt: 'FAAhbyqO57o',
      videoCover: 'world/transformer/video.jpg',
      desktop: {
        cover: 'world/transformer/cover-1.jpg',
        introRight: 'world/transformer/introRight.jpg'
      },
      mobile: {
        cover: 'world/transformer/mobile-cover-1.jpg',
        contentStyle: { width: '92%' },
        coverStyle: {
          width: '34%',
          height: 'auto',
          top: '31.5vh',
          bottom: 'inherit',
          right: '-10px',
          left: 'inherit',
          position: 'absolute'
        },
        introRight: 'world/transformer/introRight.jpg'
      },
      isCover: true
    },
    {
      type: 'memento',
      img: 'world/transformer/memento.jpg',
      imgRight: 'world/transformer/mementoRight.jpg',
      mobile: {
        contentStyle: {
          width: '77.5%',
          left: '22.5%'
        }
      },
      content:
        '쇼메의 이러한 탁월한 주얼리 메이킹 노하우는 트레져 다프리크(Trésors d’Afrique) 하이 주얼리 컬렉션에서도 찾아볼 수 있습니다. 개미 모티브의 브로치는 이어링으로 변형 가능합니다.'
    },
    {
      type: 'column',
      middleImg: 'world/transformer/columnMiddle.jpg',
      content:
        '에메랄드가 세팅 된 이 디아뎀은 조세핀 황후의 후손인 뢰슈텐베르그 가문이 소유했던 디아뎀입니다. 마치 춤을 추는 듯 섬세하게 움직이는 꽃과 활기넘치는 정원의 생명력이 담겨있는 이 디아뎀은 브로치로도 변형 가능합니다.'
    }
  ],
  mobile: {
    mainContentStyle: { paddingBottom: '20px' }
  }
}



// WEBPACK FOOTER //
// ./src/locales/kr/worlds/transformer.js